import { Route, Routes } from "react-router-dom";
// import {
//   Dashboard,
//   Employee,
//   Leave,
//   Reports,
//   Attendace,
// } from "./view/employee/index";
import NotFound from "./view/not-found";
import {
  Dashboard,
  Leave,
  Attendace,
  Organization,
  Employees,
  ViewEmployee,
  Payroll,
  Signin,
  AdminDashboard,
  Calendar,
} from "./view/admin/index";


const AppRouter = (props) => {
  const { role } = props;

  return (
    <Routes>
      {role === "admin" ? (
        <>
          <Route exact path="/adminDashboard" element={<AdminDashboard />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/organization" element={<Organization />} />
          <Route exact path="/employees" element={<Employees />} />
          <Route exact path="/leave" element={<Leave />} />
          <Route exact path="/attendance" element={<Attendace />} />
          <Route exact path="/payroll" element={<Payroll />} />
          <Route exact path="/calendar" element={<Calendar />} />
          <Route exact path="/view-employee/:id" element={<ViewEmployee />} />
          <Route exact path="*" element={<NotFound />} />
        </>
      ) : (
        <>
          <Route exact path="/dashboard" element={<Dashboard />} />
        </>
      )}
      <Route exact path="/" element={<Signin />} />
      <Route exact path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
